/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetChannelUsersResponse
 */
export interface GetChannelUsersResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetChannelUsersResponse
     */
    users: Array<string>;
}

export function GetChannelUsersResponseFromJSON(json: any): GetChannelUsersResponse {
    return GetChannelUsersResponseFromJSONTyped(json, false);
}

export function GetChannelUsersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChannelUsersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'users': json['users'],
    };
}

export function GetChannelUsersResponseToJSON(value?: GetChannelUsersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'users': value.users,
    };
}


